import React from 'react';

function PageHeader({ title, subtitle }) {
  return (
    <div className="app-page-header">
      <h2>{title}</h2>
      {subtitle ? <p>{subtitle}</p> : null}
    </div>
  );
}

export default PageHeader;
